import React, { useContext } from 'react';

import xtareaContext from '../../context/extratareas/xtareaContext';
import proyectoContext from '../../context/proyectos/proyectoContext';

const Xtarea = ({xtarea}) => {

    // obtener la funcion del context de xtarea
    const xtareasContext = useContext(xtareaContext);
    const {eliminarXtarea, obtenerXtareas, actualizarXtarea, guardarXtareaActual} = xtareasContext;

    // extraer si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;

    // extraer el proyecto proyecto[0].id
    const [proyectoActual] = proyecto;

    // funcion que se ejecuta cuando el usuario hace click en eliminar
    const xtareaEliminar = id => {
        eliminarXtarea(id, proyectoActual._id);
        obtenerXtareas(proyectoActual.id);
    }

    // funcion que modifica el estado de las xtareas
    const cambiarEstado = () => {
        if (xtarea.estado) {
            xtarea.estado = false;
        } else {
            xtarea.estado = true;
        }
        actualizarXtarea(xtarea);
    }

    // agrega la tarea seleccionada cuando el ususario desea editarla
    const seleccionarXtarea = xtarea => {
        guardarXtareaActual(xtarea);
    }

    return (  
        <li className="tarea sombra">
            <p>{xtarea.nombre} </p>
            <div className="estado">
                {xtarea.estado
                    ? (<button
                        type="button"
                        className="completo"
                        onClick={() => cambiarEstado(xtarea)}
                        >Completo</button>
                    )
                    : (
                        <button
                        type="button"
                        className="incompleto"
                        onClick={() => cambiarEstado(xtarea)}
                        >Incompleto</button>
                    )
                }
            </div>
            <div className="acciones">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => seleccionarXtarea(xtarea)}
                >Editar</button>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => xtareaEliminar(xtarea._id)}
                >Borrar</button>
            </div>
        </li>
    );
}
 
export default Xtarea;